module.exports = __webpack_public_path__ + "880609968e61fc8e53de6d0b2f6e842e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/Assets/informationPanel.png
// module id = 1321
// module chunks = 0